import React from 'react';
import { historyExpenseAccount, sortByDateAndId } from '../../actions/expenseAccount'
import { withNamespaces } from 'react-i18next';
import { formatDate } from '../../utils'
import { IsEnglish } from '../../utils/language'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/expenseAccount.module.css';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import IconButton from '@material-ui/core/IconButton';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ExpenseAccountEdit from './ExpenseAccountEdit';
import { green } from '@material-ui/core/colors';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import AlertAlgo from '../controls/AlertSnack'
import * as storage from '../../utils/storage';
import i18next from 'i18next';
import { toDisplayDecimal, isEmpty } from '../../utils';
import FilterExpenseAccount from './FilterExpenseAccount'
import $, { escapeSelector } from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDollarToSlot, faCameraRetro, faHourglassHalf, faCircleCheck } from "@fortawesome/pro-duotone-svg-icons";

const stylesMat = theme => ({
    divAction: {
        marginTop: '15px',
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        marginRight: '5px'
    },
    icons: {
        color: '#3f51b5 !important'
    },
    dollarIcon: {
        color: '#3f51b5 !important',
        bottom: '3px !important'
    },
});

class ExpenseAccountWaiting extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            startDate: null,
            endDate: null,
            openEdit: false,
            expenseId: 0,
            openSnack: false,
            resultMessage: '',
            loadCharge: this.props.loadCharge,
            isActive: true,
            isCreditCardSupport: storage.getCreditCardSupport()
        }

        this.alert = React.createRef();
    }

    componentDidMount() {
        this.listExpenseAccount();
        this.resizeList(this.state.loadCharge);
    }

    listExpenseAccount = () => {
        let startDate = new Date();
        let endDate = new Date();

        let getInitialDate = true;

        if (this.state.loadCharge === 'O') {
            if (!isEmpty(this.state.startDate)) {
                startDate = this.state.startDate;
                endDate = this.state.endDate;
                getInitialDate = false;
            }
        }

        if (getInitialDate) {
            startDate.setDate(startDate.getDate() - 90);
        }

        historyExpenseAccount(formatDate(new Date(startDate).toISOString(), 'date'), formatDate(new Date(endDate).toISOString(), 'date'), this.state.loadCharge).then((response) => {
            if (response == null) {
                this.setState({ isActive: false });
                return;
            }

            const list = sortByDateAndId(JSON.parse(response.expenseAccount));

            this.setState({ data: list, isActive: false });
        });
    }

    handleFilter = (filters) => {
        // Sometimes there's a glitch in displaying the list
        // I had to put a setTimeout to fix the list display
        setTimeout(() => {
            this.setState({
                startDate: filters[0],
                endDate: filters[1]
            }, () => {
                this.listExpenseAccount();
            });
        }, 100)
    }

    resizeList(loadCharge) {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = $('div[data-id=headerExpenseAccount]').height();
            const offSet = loadCharge === 'O' ? 100 : 50;

            const customHeight = height - header - titleBar - offSet;

            document.querySelector('div[data-id=listExpense]').style.height = `${customHeight}px`;
            document.querySelector('div[data-id=listExpense]').style.overflowX = 'hidden';
        }, 1000);
    }

    handleClick = (id, isMandatoryComment) => {
        this.setState({ expenseId: id, isMandatoryComment: isMandatoryComment, openEdit: true });
    }

    //handleClose = (value) => {
    //    let message = '';
    //    let openSnack = false;
    //    if (typeof (value) === 'string') {
    //        message = value;
    //        openSnack = true;
    //    }

    //    this.listExpenseAccount();

    //    this.setState({ openEdit: false, resultMessage: message, openSnack: openSnack });
    //};

    //handleCloseSnack = (event, reason) => {
    //    if (reason === 'clickaway') {
    //        return;
    //    }

    //    this.setState({ openSnack: false });
    //}

    handleClose = (value) => {
        let message = '';
        if (typeof (value) === 'string') {
            message = value;

            this.alert.current.showMessageSuccess(message);
            this.listExpenseAccount();
        }

        this.setState({ openEdit: false });
    };

    render() {
        const { classes } = this.props;

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('expenseAccount:form.loading')}
            >

                {this.state.loadCharge === 'O' &&
                    <FilterExpenseAccount handleFilter={this.handleFilter} />
                }

                <div data-id="listExpense" className={styles.konekCard}>
                    <List>
                        {this.state.data.map((obj, index) =>
                            <React.Fragment key={index}>
                                <ListItem key={index} button className="listItem" onClick={() => this.handleClick(obj.expenseAccountPunchId, obj.isMandatoryComment)}>

                                    <ListItemText disableTypography={true} primary={
                                        <React.Fragment>
                                            <div>{formatDate(obj.expenseDate, 'date') + ` (${toDisplayDecimal(obj.amount, 2, true)})`}</div>
                                            <div className={styles.listSubtitle1}>{IsEnglish() ? obj.descriptionEnglish : obj.descriptionFrench}</div>
                                            {obj.serviceProviderFrench != null &&
                                                <>
                                                <div><span><b>{i18next.t('expenseAccount:form.serviceProvider')}{i18next.t('common:labelSeparator')}</b></span>&nbsp;<span>{IsEnglish() ? obj.serviceProviderEnglish : obj.serviceProviderFrench}</span></div>
                                                <div><span><b>{i18next.t('expenseAccount:form.workRegion')}{i18next.t('common:labelSeparator')}</b></span>&nbsp;<span>{IsEnglish() ? obj.workRegionEnglish : obj.workRegionFrench}</span></div>
                                                </>
                                            }
                                        </React.Fragment>
                                    } />

                                    <ListItemSecondaryAction className={classes.divAction}>
                                        {this.state.isCreditCardSupport && obj.isRefundable && <IconButton className={classes.dollarIcon} edge="end">
                                            <div className={styles.isRefundable}>
                                                <FontAwesomeIcon icon={faCircleDollarToSlot} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                            </div>
                                        </IconButton>}

                                        {obj.hasDocument && <IconButton className={classes.icons} edge="end">
                                            <FontAwesomeIcon icon={faCameraRetro} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                        </IconButton>}

                                        {obj.approved && <IconButton className={classes.icons} edge="end">
                                            <FontAwesomeIcon icon={faCircleCheck} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                        </IconButton>}

                                        {!obj.approved && <IconButton className={classes.icons} edge="end">
                                            <FontAwesomeIcon icon={faHourglassHalf} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                        </IconButton>}
                                    </ListItemSecondaryAction>

                                </ListItem>
                            </React.Fragment>
                        )}
                    </List>
                    <ExpenseAccountEdit open={this.state.openEdit} onClose={this.handleClose} expenseId={this.state.expenseId} isMandatoryComment={this.state.isMandatoryComment} />
                    <AlertAlgo ref={this.alert} />
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['expenseAccount', 'common'], { wait: true })((withStyles(stylesMat)(ExpenseAccountWaiting)));